module.exports = __webpack_public_path__ + "img/66.e5656044.jpg";